module.exports = __webpack_public_path__ + "img/discount-icon.38a14bc.png";